import { createContext, useContext, useState } from "react";

const dict = {
  en: {
    dashboard: "Dashboard", companies: "Companies (Suppliers)", hospitals: "Hospitals / Institutions",
    items: "Item / Medicine Master", purchases: "Purchase Bills", sales: "Sales Bills",
    quotations: "Quotations", inventory: "Stock & Expiry", payments: "Payments / Ledger",
    organisations: "Organisations", suppliers: "Suppliers", customers: "Customers", stockItems: "Stock & Items",
    proformas: "Proforma Invoice", challans: "Delivery Challan", tenderDashboard: "Tender Dashboard",
    allTenders: "All Tenders", emdSecurity: "EMD & Security", tenderDocuments: "Tender Documents",
    rateContracts: "Rate Contracts", tenderReports: "Tender Reports",
    tenders: "Tender Tracking", reports: "Accounting Reports", finance: "Finance Control Center", settings: "Account Settings",
    eway: "E-Way Bills", returns: "Returns (CN/DN)", admin: "Users & Security", letters: "Letter Register", loginActivity: "Login Activity",
    add: "Add New", save: "Save", cancel: "Cancel", search: "Search anything... (Ctrl+K)",
    export: "Backup / Export", totalSales: "Total Sales", totalPurchases: "Total Purchases",
    receivable: "Receivable (Hospitals)", payable: "Payable (Companies)",
    lowStock: "Low Stock Items", expiring: "Expiring Batches (90d)", stockValue: "Stock Value",
    quickActions: "Quick Actions", newPurchase: "New Purchase Bill", newSale: "New Sales Bill",
    newQuotation: "New Quotation", recentBills: "Recent Bills",
  },
  hi: {
    dashboard: "Dashboard", companies: "Company Master", hospitals: "Hospital / Sanstha Master",
    items: "Dawai / Item Master", purchases: "Kharid Bill", sales: "Bikri Bill",
    quotations: "Quotations", inventory: "Stock aur Expiry", payments: "Bhugtan / Khata Baki",
    organisations: "Organisations", suppliers: "Suppliers", customers: "Customers", stockItems: "Stock & Items",
    proformas: "Proforma Invoice", challans: "Delivery Challan", tenderDashboard: "Tender Dashboard",
    allTenders: "All Tenders", emdSecurity: "EMD & Security", tenderDocuments: "Tender Documents",
    rateContracts: "Rate Contracts", tenderReports: "Tender Reports",
    tenders: "Tender Tracking", reports: "Hisaab-Kitab Reports", finance: "Finance Control Center", settings: "Meri Company Settings",
    eway: "E-Way Bill", returns: "Maal Wapsi (Return)", admin: "Users & Security", letters: "Chitthi Register", loginActivity: "Login Activity",
    add: "Naya Add Karo", save: "Save Karo", cancel: "Cancel", search: "Kuch bhi khojo... (Ctrl+K)",
    export: "Backup / Export", totalSales: "Kul Bikri", totalPurchases: "Kul Kharid",
    receivable: "Baki Lena (Hospitals)", payable: "Baki Dena (Companies)",
    lowStock: "Kam Stock Items", expiring: "Expire Hone Wale Batch (90d)", stockValue: "Stock Ka Mulya",
    quickActions: "Turant Kaam", newPurchase: "Naya Kharid Bill", newSale: "Naya Bikri Bill",
    newQuotation: "Naya Quotation", recentBills: "Haal Ke Bill",
  },
};

const LangContext = createContext();

export const LangProvider = ({ children }) => {
  const [lang, setLang] = useState(() => localStorage.getItem("sgp_lang") || "en");
  const toggle = () => {
    const next = lang === "en" ? "hi" : "en";
    setLang(next);
    localStorage.setItem("sgp_lang", next);
  };
  const t = (key) => dict[lang][key] || dict.en[key] || key;
  return <LangContext.Provider value={{ lang, toggle, t }}>{children}</LangContext.Provider>;
};

export const useLang = () => useContext(LangContext);
